import React from 'react';  
import Layout from '../../components/UI/Layout/Layout'
import DashboardStats from '../../components/Entity/DashboardStats/DashboardStats';

function Dashboard() {
  return <Layout nonav={0} fullwidth={0} title={'დაშბოარდი'}>
   <DashboardStats/>
  </Layout> ;
}

export default Dashboard;
